import type { ThemingService } from '@fino-ui/theming';

export function initilizeTheme(themingService: ThemingService) {
  return () =>
    themingService.renderTheme({
      name: 'default',
      primaryColor: '#8dc151',
      tenant: 'none',
      tenantDisplayName: 'KWH Courier UI',
    });
}
